export const USER_MANAGEMENT_VPS_USERS_FORM = 'USER_MANAGEMENT_VPS_USERS_FORM';
export const VPS_USERS_FORM = 'VPS_USERS_FORM';

export const Status = {
  CANCELLED: 'Cancelled',
};
